import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

// import 'react-aspect-ratio/aspect-ratio.css';
import { useContainerMediaQuery } from '@infl-ts/util-block-width-context';
import { useToggle } from '@infl-ts/util-hooks';
import { Box, ButtonBase, CardActions, Chip, css, styled, Typography } from '@mui/material';
import { AspectRatio as ReactAspectRatio } from 'react-aspect-ratio';
import { Translation } from 'react-i18next';
import { ChallengeAncillaryActions } from '../challenge-ancillary-actions';
import { PointsRange } from '../points';
import { ResizableCard } from '../resizable-card';
import { RouterLink } from '../router-link';
import { TypographyTruncate } from '../typography-truncate';
import ChallengeCardImage from './challenge-card-image';
import StatusBar from './status-bar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Content = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: ", ";\n"])), function (p) {
  return p.theme.spacing(1.5, 0, 2, 2);
});

var cardStyles = function cardStyles(p) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: ", ";\n\n  '&:hover': {\n    text-decoration: none;\n  }\n\n  &:before {\n    content: ' ';\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n  }\n"])), p.theme.zIndex._1);
};

var FullCardLink = styled(RouterLink)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), cardStyles);
var FullCardButton = styled(Box)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), cardStyles);

var NewChip = function NewChip() {
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "NewChip",
    "data-source-file": "challenge-card.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(Chip, {
        label: /*#__PURE__*/_jsx(Typography, {
          variant: "buttonSmall",
          children: t('New')
        }),
        color: "primary",
        size: "small",
        sx: {
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: function zIndex(t) {
            return t.zIndex._1;
          }
        }
      });
    }
  });
};

var Headline = function Headline(_ref) {
  var headline = _ref.headline,
      truncateLines = _ref.truncateLines;
  return /*#__PURE__*/_jsx(TypographyTruncate, {
    sx: {
      maxHeight: 56
    },
    variant: "h4",
    lines: truncateLines,
    dangerouslySetInnerHTML: {
      __html: headline
    },
    "data-element": "TypographyTruncate",
    "data-component": "Headline",
    "data-source-file": "challenge-card.tsx"
  });
};

var ChallengeHeadline = function ChallengeHeadline(_ref2) {
  var onClick = _ref2.onClick,
      headline = _ref2.headline,
      replaceUrl = _ref2.replaceUrl,
      challengeLink = _ref2.challengeLink,
      truncateLines = _ref2.truncateLines;
  return onClick ? /*#__PURE__*/_jsx(Box, {
    children: /*#__PURE__*/_jsx(ButtonBase, {
      sx: {
        textAlign: 'left',
        '&:focus': {
          border: function border(t) {
            return "".concat(t.spacing(0.25), " solid ").concat(t.palette.primary.main);
          },
          borderRadius: function borderRadius(t) {
            return t.shape.borderRadius;
          }
        }
      },
      tabIndex: 0,
      onClick: onClick,
      children: /*#__PURE__*/_jsx(Headline, {
        headline: headline,
        truncateLines: truncateLines
      })
    })
  }) : /*#__PURE__*/_jsx(RouterLink, {
    sx: {
      color: 'inherit'
    },
    tabIndex: 0,
    replace: replaceUrl,
    to: challengeLink !== null && challengeLink !== void 0 ? challengeLink : '',
    children: /*#__PURE__*/_jsx(Headline, {
      headline: headline,
      truncateLines: truncateLines
    })
  });
};

var ChallengeCard = function ChallengeCard(_ref3) {
  var challenge = _ref3.challenge,
      challengeLink = _ref3.challengeLink,
      onClick = _ref3.onClick,
      _ref3$hideActions = _ref3.hideActions,
      hideActions = _ref3$hideActions === void 0 ? false : _ref3$hideActions,
      _ref3$replaceUrl = _ref3.replaceUrl,
      replaceUrl = _ref3$replaceUrl === void 0 ? false : _ref3$replaceUrl,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'vertical' : _ref3$variant;
  var headline = challenge.headline,
      banner = challenge.banner,
      category = challenge.category,
      minimumAvailablePoints = challenge.minimumAvailablePoints,
      maximumAvailablePoints = challenge.maximumAvailablePoints,
      unseen = challenge.unseen;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isHover = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      setHover = _useToggle2$.on,
      setUnhover = _useToggle2$.off;

  var isMobile = useContainerMediaQuery({
    maxWidth: 'sm'
  });
  var isTablet = useContainerMediaQuery({
    maxWidth: 'lg'
  });
  var showAncillaryActions = (isHover || isTablet) && !hideActions;
  return /*#__PURE__*/_jsx(ReactAspectRatio, {
    ratio: variant === 'vertical' ? '0.95' : '3.81',
    "data-element": "ReactAspectRatio",
    "data-component": "ChallengeCard",
    "data-source-file": "challenge-card.tsx",
    children: /*#__PURE__*/_jsxs(ResizableCard, {
      onMouseOver: setHover,
      onMouseLeave: setUnhover,
      sx: {
        minWidth: variant === 'vertical' ? '230px' : '100%',
        minHeight: variant === 'vertical' ? '241px' : '100%',
        height: 'inherit',
        width: 'inherit'
      },
      "data-element": "ResizableCard",
      "data-component": "ChallengeCard",
      "data-source-file": "challenge-card.tsx",
      children: [onClick ? /*#__PURE__*/_jsx(FullCardButton, {
        tabIndex: -1,
        onClick: onClick
      }) : /*#__PURE__*/_jsx(FullCardLink, {
        tabIndex: -1,
        replace: replaceUrl,
        to: challengeLink !== null && challengeLink !== void 0 ? challengeLink : ''
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: variant === 'vertical' ? 'column' : 'row',
          height: '100%'
        },
        "data-element": "Box",
        "data-component": "ChallengeCard",
        "data-source-file": "challenge-card.tsx",
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            position: 'relative',
            width: '100%'
          },
          "data-element": "Box",
          "data-component": "ChallengeCard",
          "data-source-file": "challenge-card.tsx",
          children: [/*#__PURE__*/_jsx(ReactAspectRatio, {
            ratio: "1.78",
            style: {
              height: '100%'
            },
            "data-element": "ReactAspectRatio",
            "data-component": "ChallengeCard",
            "data-source-file": "challenge-card.tsx",
            children: /*#__PURE__*/_jsx(ChallengeCardImage, {
              banner: banner,
              name: headline,
              "data-element": "ChallengeCardImage",
              "data-component": "ChallengeCard",
              "data-source-file": "challenge-card.tsx"
            })
          }), unseen && /*#__PURE__*/_jsx(NewChip, {})]
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            width: '100%',
            display: 'flex',
            flexDirection: variant === 'vertical' ? 'row' : 'column',
            justifyContent: variant === 'vertical' ? 'left' : 'space-between'
          },
          "data-element": "Box",
          "data-source-file": "challenge-card.tsx",
          children: [/*#__PURE__*/_jsx(Content, {
            sx: {
              pr: showAncillaryActions ? 1 : 2,
              width: '100%'
            },
            "data-element": "Content",
            "data-source-file": "challenge-card.tsx",
            children: /*#__PURE__*/_jsxs(Box, {
              sx: {
                maxHeight: 56,
                display: 'flex'
              },
              "data-element": "Box",
              "data-source-file": "challenge-card.tsx",
              children: [/*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%'
                },
                "data-element": "Box",
                "data-source-file": "challenge-card.tsx",
                children: [category ? /*#__PURE__*/_jsx(Typography, {
                  variant: "subscript",
                  children: category.name
                }) : /*#__PURE__*/_jsx(Box, {
                  sx: {
                    height: 24
                  }
                }), /*#__PURE__*/_jsx(ChallengeHeadline, {
                  onClick: onClick,
                  headline: headline,
                  replaceUrl: replaceUrl,
                  challengeLink: challengeLink,
                  truncateLines: variant === 'landscape' && isMobile ? 1 : 2,
                  "data-element": "ChallengeHeadline",
                  "data-source-file": "challenge-card.tsx"
                })]
              }), /*#__PURE__*/_jsx(ChallengeAncillaryActions, {
                showAncillaryActions: showAncillaryActions,
                challenge: challenge,
                "data-element": "ChallengeAncillaryActions",
                "data-source-file": "challenge-card.tsx"
              })]
            })
          }), /*#__PURE__*/_jsxs(CardActions, {
            disableSpacing: true,
            sx: {
              p: function p(t) {
                return t.spacing(1, 2);
              },
              display: 'flex',
              justifyContent: 'space-between',
              position: variant === 'vertical' ? 'absolute' : 'inherit',
              bottom: '0',
              width: '100%',
              background: 'inherit'
            },
            "data-element": "CardActions",
            "data-source-file": "challenge-card.tsx",
            children: [/*#__PURE__*/_jsx(PointsRange, {
              sx: {
                width: function width(t) {
                  return t.spacing(2);
                },
                height: function height(t) {
                  return t.spacing(2);
                },
                mr: 0.5
              },
              variant: "caption",
              start: minimumAvailablePoints,
              end: maximumAvailablePoints,
              "data-element": "PointsRange",
              "data-source-file": "challenge-card.tsx"
            }), /*#__PURE__*/_jsx(StatusBar, {
              challenge: challenge,
              onClick: onClick,
              challengeLink: challengeLink,
              replaceUrl: replaceUrl,
              "data-element": "StatusBar",
              "data-source-file": "challenge-card.tsx"
            })]
          })]
        })]
      })]
    })
  });
};

export default ChallengeCard;